import React from 'react';
import { Link, useLocation } from 'react-router-dom';

import { singleTitleMapping, resolveBreadcrumbTitles } from './Components/TitleMappings';
import PageHeaderAction from './Components/PageHeaderAction';

const CommonBreadcrumb = () => {
  const location = useLocation();
  const pathname = location.pathname;

  // ✅ Get breadcrumb title list dynamically
  const breadcrumbParts = resolveBreadcrumbTitles(pathname, singleTitleMapping);

  return (
    <div className="px-xl-5 px-lg-4 px-3 py-2 page-header">
      <ol className="breadcrumb mb-0 bg-transparent">
        <li className="breadcrumb-item">
          <Link to={pathname === '/index-hr' ? '/index-hr' : '/'}>Home</Link>
        </li>

        {breadcrumbParts.map((part, index) => (
          <li
            key={part.path}
            className={`breadcrumb-item ${index === breadcrumbParts.length - 1 ? 'active' : ''}`}
          >
            {index === breadcrumbParts.length - 1 ? (
              <span>{part.title}</span>
            ) : (
              <Link to={part.path}>{part.title}</Link>
            )}
          </li>
        ))}
      </ol>

      <ul className="list-unstyled action d-flex align-items-center mb-0">
        <PageHeaderAction />
      </ul>
    </div>
  );
};

export default CommonBreadcrumb;
